module.exports = __webpack_public_path__ + "img/arrow-left.554af99d.svg";